import useAdminNewsletter from "@/hooks/useAdminNewsletter";
import useMilestoneCelebration from "@/hooks/useMilestoneCelebration";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminStats from "@/components/admin/AdminStats";
import SubscriberMilestone from "@/components/admin/SubscriberMilestone";
import MilestoneCelebrationBanner from "@/components/admin/MilestoneCelebrationBanner";
import MonthlyDraft from "@/components/admin/MonthlyDraft";
import SocialWebhookTester from "@/components/admin/SocialWebhookTester";
import NewsletterComposer from "@/components/admin/NewsletterComposer";
import ScheduledList from "@/components/admin/ScheduledList";
import BroadcastAnalytics from "@/components/admin/BroadcastAnalytics";

const SAMPLE_BODY = `<!-- ESTO ES UNA PLANTILLA DE AYUDA. Bórrala y escribe tu newsletter real. -->

<p>Hola {name},</p>

<p>[Aquí escribe tu introducción del mes. Algo personal, breve, que enganche desde la primera frase. 2-3 líneas máximo.]</p>

<p style="font-family:Georgia,serif;font-style:italic;color:#D4774A;">[Aquí va la frase emocional destacada del mes. La que quieras que la gente recuerde.]</p>

<p>[Aquí va el cuerpo principal: una reflexión, una historia, un aprendizaje. 3-4 párrafos.]</p>

<p>El recurso de este mes:</p>
<ul>
  <li>[Una respiración o práctica concreta]</li>
  <li>[Un artículo del blog: <a href="https://metodo-tao.com/blog/SLUG">título</a>]</li>
  <li>[Una práctica de 5 minutos]</li>
</ul>

<p>Cuídate mucho,<br>
<strong style="color:#D4774A;">Marta</strong></p>`;

const AdminNewsletter = () => {
  const a = useAdminNewsletter(SAMPLE_BODY);
  const { celebrating, dismiss } = useMilestoneCelebration(
    a.loggedIn ? a.stats?.subscribers_total : null
  );

  if (!a.loggedIn) {
    return (
      <AdminLogin
        password={a.password}
        setPassword={a.setPassword}
        onSubmit={a.login}
        loading={a.loading}
      />
    );
  }

  return (
    <div className="bg-ivory min-h-screen pb-20" data-testid="admin-dashboard">
      <MilestoneCelebrationBanner milestone={celebrating} onDismiss={dismiss} />
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 pt-12">
        <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-3">Panel privado</p>
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal">
          Newsletter <span className="italic text-terracotta">Método TAO</span>
        </h1>

        <AdminStats stats={a.stats} />

        <SubscriberMilestone
          count={a.stats?.subscribers_total || 0}
          onSendWeeklySummary={a.sendWeeklySummary}
          loading={a.loading}
        />

        <MonthlyDraft password={a.password} loggedIn={a.loggedIn} />

        <SocialWebhookTester password={a.password} loggedIn={a.loggedIn} />

        <NewsletterComposer
          subject={a.subject}
          setSubject={a.setSubject}
          bodyHtml={a.bodyHtml}
          setBodyHtml={a.setBodyHtml}
          scheduledAt={a.scheduledAt}
          setScheduledAt={a.setScheduledAt}
          preview={a.preview}
          setPreview={a.setPreview}
          loading={a.loading}
          sendTest={a.sendTest}
          sendBroadcast={a.sendBroadcast}
          subscribersTotal={a.stats?.subscribers_total || 0}
        />

        <ScheduledList
          scheduled={a.stats?.scheduled || []}
          loading={a.loading}
          onCancel={a.cancelScheduled}
        />

        <BroadcastAnalytics password={a.password} loggedIn={a.loggedIn} />
      </div>
    </div>
  );
};

export default AdminNewsletter;
